import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { RequestResponse } from "../intefaces/requestResponse";

@Injectable({
  providedIn: "root",
})
export class NewsletterService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
  }

  public getCategories(isLogin: boolean, key: string, adminUserId: number) {
    let params = new HttpParams();

    let url = "newsletter/categories_guest";
    if (isLogin) {
      url = "newsletter/categories";
    }
    if (adminUserId) {
      url = "newsletter/categories_admin";
      params = params.set("userId", adminUserId.toString());
    }

    if (key) {
      params = params.set("key", key);
    }

    return this.http.get<RequestResponse>(this.setUrl(url), { params });
  }

  public saveNewsletter(value) {
    return this.http.post<RequestResponse>(
      this.setUrl("newsletter/save"),
      value
    );
  }

  public updateOptions(
    isLogin: boolean,
    options: number[],
    key: string,
    adminUserId: number
  ) {
    let url = "newsletter/updateOptions";
    if (isLogin) {
      url = "newsletter/updateUserLogin";
    }
    if (adminUserId) {
      url = "newsletter/updateUserAdmin";
    }

    return this.http.post<RequestResponse>(this.setUrl(url), {
      options: options,
      key: key,
      userId: adminUserId,
    });
  }

  public getAll() {
    return this.http.get<RequestResponse>(this.setUrl("newsletter/all"));
  }

  public getById(id: string) {
    const params = new HttpParams().set("id", id);
    return this.http.get<RequestResponse>(this.setUrl("newsletter/getById"), {
      params,
    });
  }
}
